export enum LoginFormFields {
    username = 'username',
    password = 'password',
    isTools = 'isTools',
}

export enum ForgotPasswordFormFields {
    email = 'email',
}

export enum ResetPasswordFormFields {
    password = 'password',
    passwordReEntry = 'passwordReEntry',
}
export interface ILoginForm {
    [LoginFormFields.username]: string;
    [LoginFormFields.password]: string;
    [LoginFormFields.isTools]: boolean;
}

export interface IForgotPasswordForm {
    [ForgotPasswordFormFields.email]: string;
}
export interface IResetPasswordForm {
    [ResetPasswordFormFields.password]: string;
    [ResetPasswordFormFields.passwordReEntry]: string;
}
